/**
 * API 기본 설정
 */

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.ilouli.com';

/**
 * 토큰 조회
 */
export const getToken = () => {
  const TOKEN_KEY = 'ilouli_token';

  // 먼저 쿠키에서 찾기
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === TOKEN_KEY) {
      return decodeURIComponent(value);
    }
  }

  // 쿠키에 없으면 localStorage 백업에서
  try {
    const backupToken = localStorage.getItem(`${TOKEN_KEY}_backup`);
    if (backupToken) {
      return backupToken;
    }
  } catch (e) {
    console.warn('Failed to get token from backup:', e);
  }

  return null;
};

/**
 * API 요청 헬퍼
 */
export const apiRequest = async (endpoint, options = {}) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers
  };

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
    credentials: 'include'
  });

  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.error || 'Request failed');
    error.status = response.status;
    throw error;
  }

  return data;
};

export default apiRequest;
